var map = {
	"./analytics/store/analytics.store.ts": 1308,
	"./article/store/article.store.ts": 1309,
	"./category/store/category.store.ts": 1310,
	"./customer/store/bookmarks.store.ts": 1311,
	"./frontpage/store/frontpage.store.ts": 1312,
	"./navigation/store/navigation.store.ts": 1313,
	"./podcast/store/podcast.store.ts": 1314,
	"./weather/store/weather.store.ts": 1315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1307;